import { useEffect, type ReactNode } from 'react'
import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'

/**
 * Capacitor Platform Provider
 *
 * Handles native platform initialization:
 * - Status bar configuration (not overlaying WebView content)
 * - Safe area setup for Android
 */
export function CapacitorProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const initializeNative = async () => {
      if (!Capacitor.isNativePlatform()) {
        return
      }

      try {
        // Configure status bar to NOT overlay WebView content
        // This makes content start below the status bar instead of behind it
        await StatusBar.setOverlaysWebView({ overlay: false })

        // Set status bar style (light content on dark background or vice versa)
        await StatusBar.setStyle({ style: Style.Light })

        // Set background color to match app theme
        if (Capacitor.getPlatform() === 'android') {
          await StatusBar.setBackgroundColor({ color: '#ffffff' })
        }
      } catch (error) {
        console.error('Failed to configure status bar:', error)
      }
    }

    initializeNative()
  }, [])

  return <>{children}</>
}
